import { Component } from '@angular/core';
import { AbstractModal } from '../../../../shared/models/abstract-modal';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-identify-error-modal',
  templateUrl: './identify-error-modal.component.html',
  styleUrls: ['./identify-error-modal.component.scss'],
})
export class IdentifyErrorModalComponent extends AbstractModal {
  constructor(protected ngbActiveModal: NgbActiveModal) {
    super(ngbActiveModal);
  }
}
